/**
 * Student ID vs institute roll number (reports / exports).
 * Roll number must not fall back to system-generated studentLoginID.
 */

export function getInstituteRollNumber(student) {
  if (!student) return "";
  const raw = student.rollNumber ?? student.roll_number ?? student.rollNo;
  if (raw == null || raw === "" || raw === "-") return "";
  return String(raw).trim();
}

export function getSystemStudentId(student) {
  if (!student) return "";
  const raw = student.studentId ?? student.student_id;
  if (raw == null || raw === "") return "";
  const trimmed = String(raw).trim();
  if (trimmed === "-" || trimmed.toLowerCase() === "n/a") return "";
  return trimmed;
}

export function studentReportIdentityFields(student) {
  const rollNumber = getInstituteRollNumber(student);
  const studentId = getSystemStudentId(student);
  return { studentId, rollNumber, rollNo: rollNumber };
}
